import { GlobalState } from '../types/common';
import {
  payload as payloadData
} from '../types/regulatoryUpdateBundle';

const removePhoneNumberFormatting = (value: string): string => value.replace(/[ ()-]/g, '');

export const getPayloadObject = (payloadParams, phoneNumberCode?: string) => {
  const phoneNumber = (payloadParams.isLoggedIn || !phoneNumberCode ? '' : phoneNumberCode) + removePhoneNumberFormatting(payloadParams.customer.phone);
  let payload: payloadData = {
    email: payloadParams.customer.email,
    phoneNumber: phoneNumber,
    action: payloadParams.action,
    attributes: {
      customerAgentInfo: {
        customer: {
          ...payloadParams.customer,
          phone: phoneNumber
        }
      }
    }
  };

  if (payloadParams.isLoggedIn) {
    payload.requestType = payloadParams.requestType;
    payload.uuid = payloadParams.uuid;
  } else {
    payload.requestType = payloadParams.actionSubjectValue.actionValue;
    payload.uuid = '';

    if (payloadParams?.actionSubjectValue?.subjectValue === 'AGENT') {
      payload.attributes.customerAgentInfo.agent = {
        ...payloadParams.agent,
        phone: (phoneNumberCode || '') + removePhoneNumberFormatting(payloadParams.agent.phone)
      };
    }
  }

  return payload;
};

export const action = { CCPA: 'ccpa', DONOTSELL: 'do_not_sell' };
export const subjectValue = {
  AGENT: 'AGENT',
  CUSTOMER: 'CUSTOMER'
};
export const subjectTitle = { CUSTOMER: 'Customer', AGENT: 'Agent' };
export const actionData = {
  RETRIEVE: 'RETRIEVE',
  DELETE: 'DELETE'
};

const successPopupThanksText = {
  privacyPolicyCustomerThankyou: 'Thank you. Your request has been received and a representative will get back to you soon.',
  privacyPolicyAgentThankyou: 'Thank you. Your request has been received. We will send the customer an authorized agent form to complete.'
};

// eslint-disable-next-line consistent-return
export const getThanksText = (value: string): string => {
  if (value === 'CUSTOMER') {
    return successPopupThanksText.privacyPolicyCustomerThankyou;
  }

  if (value === 'AGENT') {
    return successPopupThanksText.privacyPolicyAgentThankyou;
  }
};
